var ta = {
	init: function(){
		$(".cube_wrap").addClass("start");
	}
}